import { AxiosError } from 'axios'
import { errorMessagesByCode } from './messageByStatusCode'

interface IReturnError {
    message: string
    status?: number
}

export default function errorHandler(error: unknown): IReturnError {
    if (error instanceof AxiosError) {
        // eslint-disable-next-line
        console.error({ error })

        const { request, response } = error

        if (response && response.status && Object.prototype.hasOwnProperty.call(errorMessagesByCode, response.status)) {
            const statusCode: number = response.status
            const message = (response.data && response.data.message) || errorMessagesByCode[statusCode]
            const { status } = response

            return {
                message,
                status,
            }
        }

        if (response && response.data && response.data.message) {
            const { message } = response.data
            const { status } = response

            return {
                message,
                status,
            }
        }

        if (request) {
            return {
                message: 'Erro interno do servidor',
                status: 503,
            }
        }

        return {
            message: 'Oops! Verifique a sua conexão com a internet',
        }
    }

    if (error instanceof Error) {
        return {
            message: error.message ?? 'Oops! Tivemos um problema na conexão',
        }
    }

    return {
        message: 'Oops! Recarregue a página',
    }
}
